import {
  IconFileFilled,
  IconPlayerRecord,
  IconVideo,
} from '@tabler/icons-react';
import { PhotoView } from 'react-photo-view';
import { Image, Stack, Text } from '@mantine/core';
import { DAttachmentUploadMeta } from '@/src/modules/chat/data/dtos/attachment-upload-meta';

interface IChatAttachmentPreviewProps {
  fileMeta: DAttachmentUploadMeta;
}

export function ChatAttachmentPreview({
  fileMeta,
}: IChatAttachmentPreviewProps) {
  if (fileMeta.file.type.startsWith('image/')) {
    return (
      <PhotoView src={fileMeta.previewUrl}>
        <Image src={fileMeta.previewUrl} w="100%" h="100%" bdrs="0.2rem" />
      </PhotoView>
    );
  }

  if (fileMeta.file.type.startsWith('audio/')) {
    return (
      <Stack gap={1} align="center" justify="center">
        <IconPlayerRecord color="gray" width="60%" height="60%" />
        <Text fz="xs" truncate="end" w="100%">
          {fileMeta.file.name}
        </Text>
      </Stack>
    );
  }

  if (fileMeta.file.type.startsWith('video/')) {
    return (
      <Stack gap={1} align="center" justify="center">
        <IconVideo color="gray" width="60%" height="60%" />
        <Text fz="xs" truncate="end" w="100%">
          {fileMeta.file.name}
        </Text>
      </Stack>
    );
  }

  return (
    <Stack gap={1} align="center" justify="center">
      <IconFileFilled color="gray" width="60%" height="60%" />
      <Text fz="xs" truncate="end" w="100%">
        {fileMeta.file.name}
      </Text>
    </Stack>
  );
}
